
import {
  cleanUpMessageUser,
  cleanUpUser,
  fetchGetUser,
  fetchDeleteUser,
  fetchGetUsers,
  fetchPostUser,
  fetchPutUser
} from 'state-managament/user.slice'

import { useDispatch, useSelector } from 'react-redux';


export default function useUser () {
  const { 
    error, 
    success, 
    isLoaded, 
    data
    } = useSelector(state => state.userManager  );
 
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpUser());
  const cleanUpMessage = () => dispatch(cleanUpMessageUser());
  const getUser = (args) => dispatch(fetchGetUser(args));
  const getUsers = (args) => dispatch(fetchGetUsers(args));
  const postUser = (args) => dispatch(fetchPostUser(args));
  const deleteUser = (args) => dispatch(fetchDeleteUser(args));
  const putUser = (args) => dispatch(fetchPutUser(args));

  return {
    error,
    success,
    isLoaded,
    data,
    cleanUp,
    cleanUpMessage,
    getUser,
    getUsers,
    postUser,
    deleteUser,
    putUser,
  }
}
